import { objectHelper } from "@/_shared/utils";

const { createCopy } = objectHelper;

const adaptProjectForm = (record) => {
  record.user_id = createCopy(record.user);
  record.user_id.calendar_id = createCopy(record.user_id.shifts_calendar);
  delete record.user_id.shifts_calendar;
  delete record.user;

  record.products_data = record.products_data.map((product) => {
    if (product.each_item_deadline !== null) {
      product.each_item_deadline = new Date(product.each_item_deadline);
    }
    product.quantity_data = JSON.parse(product.quantity_data);
    return product;
  });
  return record;
};

const responseAdapter = {
  adaptProjectForm,
};

export default responseAdapter;



// WEBPACK FOOTER //
// ./src/_shared/api-services/_responseAdapter.js